import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useApi } from "../auth";
import { MimboxData } from "../interfaces/mimbox-data";
import { StoreContextType } from "../interfaces/store-context-type";
import FileSaver from "file-saver";

// TODO fix interface
export interface StoreData {
  economyData: string;
  waterData?: number | null;
  carbonDioxideData: string;
  microplasticsData: string;
}

// TODO fix interface
interface StoreProps {
  children: ReactNode;
}

const StoreContext = createContext<StoreContextType>({} as StoreContextType);

export const StoreProvider: React.FC<StoreProps> = ({ children }) => {
  const { api, pdfApi } = useApi();

  const [mimboxData, setMimboxData] = useState<MimboxData>();
  const [loading, setLoading] = useState<boolean>(false);
  const [downloading, setDownloading] = useState<boolean>(false);
  const [enableDemo, setEnableDemo] = useState(false);

  const memoizedOnGetBoxData = useCallback(async () => {
    setLoading(true);
    const data = await api.getMimboxData(enableDemo);
    setMimboxData(data?.data as MimboxData);
    setLoading(false);
  }, [api, enableDemo]);

  const memoizedOnGetPdf = useCallback(async () => {
    setDownloading(true);
    const pdf = await pdfApi.getPdf();
    if (pdf?.data && pdf.data !== {}) {
      const blobData = pdf.data as any;
      const data = blobData.pdf.data;
      const buffer = Uint8Array.from(data);
      const blob = new Blob([buffer as BlobPart], {
        type: "application/pdf",
      });
      FileSaver.saveAs(blob, `${mimboxData?.customerName}.pdf`);
    }
    setDownloading(false);
  }, [pdfApi, mimboxData]);

  useEffect(() => {
    if (!mimboxData) {
      memoizedOnGetBoxData();
    }
  }, [mimboxData, memoizedOnGetBoxData]);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const isDemoParam: string = params.get("demo") || "";
    setEnableDemo(isDemoParam === "true");
  }, []);

  const state = {
    data: mimboxData,
    generatePdf: memoizedOnGetPdf,
    loading,
    downloading,
  };

  const providerValue = useMemo(() => state, [state]);

  return (
    <StoreContext.Provider value={providerValue}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
